import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequisition } from "src/models/Products/Requisition.models";

interface RequisitionState {
    requisitions: IRequisition[];
    requisitionToEdit: IRequisition | null;
}

const initialState: RequisitionState = {
    requisitions: [],
    requisitionToEdit: null,
};

const RequisitionSlice = createSlice({
    name: "Requisition",
    initialState,
    reducers: {
    setRequisitionList: (
        state,
        action: PayloadAction<IRequisition[]>
    ) => {
        state.requisitions = action.payload;
    },
    concatListRequisition: (
        state: RequisitionState,
        action: PayloadAction<IRequisition[]>
    ) => {
        state.requisitions = [
            ...state.requisitions.concat(action.payload),
        ];
    },
    setRequisitionToEdit: (
        state,
        action: PayloadAction<IRequisition | null>
    ) => {
        state.requisitionToEdit = action.payload;
    },
    addRequisition: (state, action: PayloadAction<IRequisition>) => {
        state.requisitions.push(action.payload);
    },
    updateRequisition: (state, action: PayloadAction<IRequisition>) => {
        let itemIndex = state.requisitions.findIndex(
            item => item.requisitionId === action.payload.requisitionId
        );
        if (itemIndex !== -1) state.requisitions[itemIndex] = action.payload;
    },
    deleteRequisition: (state, action: PayloadAction<number>) => {
        const newArray = state.requisitions.filter(
            item => item.requisitionId !== action.payload
        );
        state.requisitions = newArray;
    },
    },
});

export const {
    setRequisitionList,
    concatListRequisition,
    setRequisitionToEdit,
    addRequisition,
    updateRequisition,
    deleteRequisition,
} = RequisitionSlice.actions;

export default RequisitionSlice.reducer;